import { useEffect, useRef, useState } from "react";
import check from "../../assets/images/check.png";
import * as Icon from "react-feather";
import { useDispatch, useSelector } from "react-redux";
import { SiteActionCreators, SiteActions } from "../../store/actions/site";

function SiteSelector({ onSelect }) {
  const [open, setOpen] = useState(false);

  const selectedSite = useSelector((state) => state.site?.selectedSite);
  const sites = useSelector((state) => state.site?.sites ?? []);

  const dispatch = useDispatch();

  const selectorRef = useRef();

  const handleClickOutside = (event) => {
    if (selectorRef.current && !selectorRef.current.contains(event.target)) {
      if (open) {
        setOpen(false);
      }
    }
  };

  const handleSelect = (site) => () => {
    dispatch({
      type: SiteActions.SELECT_SITE,
      payload: { site: site },
    });
    dispatch(SiteActionCreators.getSite(site.id));

    if (onSelect) onSelect(site);
    setOpen(false);
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [open]);

  return (
    <div ref={selectorRef}>
      <div
        onClick={() => setOpen((prev) => !prev)}
        id="siteSelector"
        className="pr-3 mb-1 rounded-md cursor-pointer hover:text-indigo-500 outline-none flex items-center justify-between text-md font-semibold"
      >
        <div className="inline-flex">
          <span
            id="selectedSiteTitle"
            className="ml-2 inline group-hover:inline text-xl"
          >
            {selectedSite?.fqdn ??
              (selectedSite?.virgulId === "all-sites" && "All Sites")}
          </span>
        </div>
        {sites.length > 1 && (
          <Icon.ChevronDown
            className={`transform ${
              open ? "rotate-180" : ""
            } transition-transform ml-2`}
            width="13"
            height="13"
          />
        )}
      </div>

      <div
        style={{ width: "270px" }}
        className={`${
          open ? "absolute" : "hidden"
        } px-3 py-2 my-1 cursor-pointer hover:text-indigo-500 items-center justify-between text-md font-semibold bg-gray-100 border-gray-300 shadow-lg rounded-lg z-80`}
      >
        {sites.map((site) => (
          <div
            onClick={handleSelect(site)}
            key={site.fqdn}
            className="px-3 py-2 mb-1 rounded-md cursor-pointer hover:text-indigo-500 outline-none flex items-center justify-between text-md font-semibold text-gray-600"
          >
            <div className="flex">
              <span className="ml-2 inline group-hover:inline">
                {site.fqdn}
              </span>
            </div>
            {(site.id === selectedSite?.id ||
              site.virgulId === selectedSite?.virgulId) && (
              <img
                style={{ width: "20px" }}
                alt=""
                className="float-right mr-1"
                src={check}
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default SiteSelector;
